import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import hero1 from "../../assets/hero_security.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import hero2 from "../../assets/hero_1.png";
import hero3 from "../../assets/hero_2.png";
import hero4 from "../../assets/hero_3.png";
import hero5 from "../../assets/hero5.png";
import hero6 from "../../assets/hero_5.png";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 13,
          py: 6,
          backgroundColor: "#fff",
          gap: 8,
          marginTop: "70px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <CustomText
            style={{
              ...textStyles.h1,
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: isMobile ? "0rem" : "1rem",
              fontSize: isMobile ? "36px" : "52px",
              textAlign: isMobile ? "center" : "left",

              // maxWidth:"400px"
            }}
          >
            {t("new_Security_title")}
          </CustomText>

          <CustomText
            style={{
              ...textStyles.body1,
              color: "#868282",
              //  maxWidth: "1175px",
              margin: "0 auto",
              marginTop: "10px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {t("new_Security_subtitle")}
          </CustomText>
          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary"
              size="large"
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
              }}
            >
              <img
                src={more || "/placeholder.svg"}
                style={{ width: "65px", height: "65px" }}
              />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  cursor: "pointer",
                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 0 },
          }}
        >
          <Box
            component="img"
            src={hero1}
            alt="Dashboard Preview"
            sx={{
              width: "100%",
              maxWidth: "500px",
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box>
        <Box id="face-recognition-validation">
          <FeaturesHeroCard
            bgColor="#EFF4F8"
            image={hero2}
            imagePosition="left"
            title={t("new_Data_Protection_Validation_title")}
            description={t("new_Data_Protection_Validation_description")}
            features={[
              t("new_Data_Protection_Validation_feature_1"),
              t("new_Data_Protection_Validation_feature_2"),
              t("new_Data_Protection_Validation_feature_3"),
            ]}
          />
        </Box>
        <Box id="break-time-tracking">
          <FeaturesHeroCard
            bgColor="#FFFFFF"
            image={hero3}
            imagePosition="left"
            title={t("new_User_Authentication_title")}
            description={t("new_User_Authentication_description")}
            features={[
              t("new_User_Authentication_feature_1"),
              t("new_User_Authentication_feature_2"),
              t("new_User_Authentication_feature_3"),
            ]}
          />
        </Box>
        <Box id="historical-attendance-insights">
          <FeaturesHeroCard
            bgColor="#EFF4F8"
            image={hero4}
            imagePosition="right"
            title={t("new_Privacy_Compliance_Insights_title")}
            description={t("new_Privacy_Compliance_Insights_description")}
            features={[
              t("new_Privacy_Compliance_Insights_feature_1"),
              t("new_Privacy_Compliance_Insights_feature_2"),
              t("new_Privacy_Compliance_Insights_feature_3"),
            ]}
          />
        </Box>
        <Box id="offline-clocking-support">
          <FeaturesHeroCard
            bgColor="#FFFFFF"
            image={hero5}
            imagePosition="left"
            title={t("new_Security_Education_title")}
            description={t("new_Security_Education_description")}
            features={[
              t("new_Security_Education_feature_1"),
              t("new_Security_Education_feature_2"),
              t("new_Security_Education_feature_3"),
            ]}
          />
        </Box>
        <Box id="custom-rules-restrictions">
          <FeaturesHeroCard
            bgColor="#EFF4F8"
            image={hero6}
            imagePosition="right"
            title={t("new_Security_Integretion_title")}
            description={t("new_Security_Integretion_description")}
            features={[
              t("new_Security_Integretion_feature_1"),
              t("new_Security_Integretion_feature_2"),
              t("new_Security_Integretion_feature_3"),
            ]}
          />
        </Box>
      </Box>
    </>
  );
};
export default HeroSection;
